import gql from 'graphql-tag';

const SubscriptionFragment = gql`
  fragment Subscription on subscriptions {
    id
    plan_id
    signup_fee
    start_date
    end_date
    tier_prices
    total
    status
    installments
    installment_amount
    cancelled_at
    student_id
    stripe_customer_id
  }
`;

const ProductFragment = gql`
  fragment Product on products {
    id
    plan_id
    package_name
    pricing_model
    installments
    total
    tier_prices
    signup_fee
    product_type
    credits
    contract_filename
    stripe_product_id
    service_details
    program_start_date
    program_end_date
    curriculum_id
    timeline_id
    active
    trial_days
    graduation_year
    mbg_period
    config
  }
`;

export const GET_PRODUCTS = gql`
  query getProducts($graduation_year: Int) {
    products(where: { graduation_year: { _eq: $graduation_year } }) {
      ...Product
    }
  }
  ${ProductFragment}
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation createSub($studentId: Int!, $planId: String!, $token: String!) {
    create_subscription(
      input: { payment_token: $token, plan_id: $planId, student_id: $studentId }
    ) {
      id
    }
  }
`;

export const GET_SUBSCRIPTIONS = gql`
  query getSubscriptions($studentId: Int!) {
    subscriptions(
      where: { student_id: { _eq: $studentId }, status: { _eq: "active" } }
    ) {
      ...Subscription
    }
  }
  ${SubscriptionFragment}
`;

export const GET_PRODUCT_BY_PLAN_ID = gql`
  query getProduct($planId: String!) {
    products(where: { plan_id: { _eq: $planId } }) {
      ...Product
    }
  }
  ${ProductFragment}
`;

export const GET_ALL_PRODUCTS = gql`
  query {
    products(order_by: { package_name: asc }) {
      ...Product
    }
  }
  ${ProductFragment}
`;

export const UPSERT_PRODUCT = gql`
  mutation upsertProduct($data: products_insert_input!) {
    insert_products_one(
      object: $data
      on_conflict: {
        constraint: products_pkey
        update_columns: [
          plan_id
          package_name
          product_type
          pricing_model
          installments
          total
          tier_prices
          signup_fee
          contract_filename
          stripe_product_id
          credits
          service_details
          program_start_date
          program_end_date
          active
          mbg_period
          curriculum_id
          timeline_id
          trial_days
          graduation_year
          config
        ]
      }
    ) {
      ...Product
    }
  }
  ${ProductFragment}
`;

export const UPSERT_ADDON = gql`
  mutation upsertAddon($data: addons_insert_input!) {
    insert_addons_one(
      object: $data
      on_conflict: {
        constraint: addons_id_key
        update_columns: [
          package_name
          product_type
          credit_type
          credits
          price
          extension_days
          addon_info
          class_year
        ]
      }
    ) {
      id
      package_name
      product_type
      credit_type
      credits
      price
      extension_days
      addon_info
    }
  }
`;

export const GET_ALL_ADDONS = gql`
  query {
    addons {
      id
      package_name
      credit_type
      product_type
      credits
      price
      extension_days
      addon_info
      class_year
    }
  }
`;

export const GET_ADDONS_BY_TYPE = gql`
  query getProductByType($jsonFilter: jsonb) {
    addons(where: {product_type: {_contains: [$jsonFilter]}}) {
      id
      package_name
      credit_type
      product_type
      credits
      price
      extension_days
      addon_info
      class_year
    }
  }
`;
